import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Reviews.css";

const Reviews = () => {
    const authorSlider = useRef(null);
    const feedbackSlider = useRef(null);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);

    useEffect(() => {
        setNav1(authorSlider.current);
        setNav2(feedbackSlider.current);
    }, []);

    const authorSliderSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        focusOnSelect: true,
        swipe: true,
        speed: 500,
        easing: 'easeOutElastic',
        asNavFor: nav2,
        className: 'author-slider'
    };

    const feedbackSliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        fade: false,
        swipe: false,
        asNavFor: nav1,
        className: 'feedback-slider'
    };

    const testimonials = [
        {
            name: "Dr. Suresh Kumar",
            location: "Bengaluru, Karnataka",
            image: "//css.meddylist.com//wp-content/uploads/2025/04/2.jpg",
            quote: "As a general physician, I appreciate how MeddyList verifies every specialist. My patients have been thrilled with the quality and reliability of care they receive."
        },
        {
            name: "Dr. Aruna Patel",
            location: "Ahmedabad, Gujarat",
            image: "//css.meddylist.com//wp-content/uploads/2025/04/1.jpg",
            quote: "MeddyList made it so easy for me to find the right cardiologist. The appointment was booked in minutes and the follow-up reminders kept me on track with my care."
        },
        {
            name: "Dr. Neha Sharma",
            location: "Mumbai, Maharashtra",
            image: "//css.meddylist.com//wp-content/uploads/2025/04/3.jpg",
            quote: "Booking online appointments used to be a headache—now it's seamless. I've seen a 30% increase in my patients scheduling follow-ups on time."
        },
        {
            name: "Dr. Rajiv Singh",
            location: "Chandigarh, Punjab",
            image: "//css.meddylist.com//wp-content/uploads/2025/04/4.jpg",
            quote: "The feedback feature on MeddyList helps me continuously improve my practice. I love seeing real-time reviews and adjusting my services accordingly."
        }
    ];

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-eddc686 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default" style={{ backgroundImage: 'url(//css.meddylist.com//wp-content/uploads/2019/08/banner-img.png)' }}>
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ba5182c">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-a0a2f1e elementor-widget elementor-widget-dc_element_feedback">
                            <div className="elementor-widget-container">
                                <div className="dc-feedback dc-testimonials-holder dc-haslayout">
                                    <div className="dc-testimonials">
                                        <div className="container">
                                            <div className="row justify-content-center align-self-center">
                                                <div className="col-xs-12 col-sm-12 col-md-8 col-md-push-2 col-lg-8 col-lg-push-2">
                                                    <div className="dc-testimonials-head">
                                                        <div className="dc-heart">
                                                            <span className="dc-hearticon"><i className="lnr lnr-heart"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-10 col-md-push-1 col-lg-8 col-lg-push-2">
                                                    <div className="dc-customerfeedbacks">
                                                        <Slider ref={authorSlider} {...authorSliderSettings}>
                                                            {testimonials.map((testimonial, index) => (
                                                                <div key={index} className="dc-slide">
                                                                    <figure>
                                                                        <img src={testimonial.image} alt={testimonial.name} />
                                                                    </figure>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                        <Slider ref={feedbackSlider} {...feedbackSliderSettings}>
                                                            {testimonials.map((testimonial, index) => (
                                                                <div key={index} className="dc-testimonialscontent">
                                                                    <div className="dc-description">
                                                                        <blockquote>
                                                                            <p>{testimonial.quote}</p>
                                                                        </blockquote>
                                                                    </div>
                                                                    <div className="dc-title">
                                                                        <h3>{testimonial.name}</h3>
                                                                        <span>{testimonial.location}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Reviews;
